<template>
  <Drawer
    v-model:visible="drawerService.state.visible"
    v-bind="drawerService.state.options"
    @after-hide="drawerService.close()"
  >
    <template #default>
      <div
        v-if="drawerService.state.isRawHtml"
        v-html="drawerService.state.content"
      />
      <component
        :is="drawerService.state.content"
        v-bind="drawerService.state.options.componentProps"
        v-else
      />
    </template>
  </Drawer>
</template>

<script setup>
import { inject } from "vue"

const drawerService = inject("drawerService")
</script>
